import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d93b57e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plan-details-card-header justify-content-center plan-amount pt-4" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "d-flex justify-center pb-4" }, "Jtel Support")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "note text-center mt-0 px-6"
}
const _hoisted_3 = { class: "mt-7" }
const _hoisted_4 = { class: "mb-3 px-4" }
const _hoisted_5 = { class: "mb-3 px-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1 color-red" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*")
], -1))
const _hoisted_7 = { class: "mb-3 px-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-1 color-red" }, [
  /*#__PURE__*/_createElementVNode("b", null, "*")
], -1))
const _hoisted_9 = { class: "mb-3 px-4" }
const _hoisted_10 = { class: "mb-3 px-4" }
const _hoisted_11 = { class: "mb-3 mt-6" }
const _hoisted_12 = {
  key: 1,
  class: "text-center mt-12"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-6 mx-6 font-xs" }, "We have received your support request. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mx-6 mb-10" }, "Our Team will get in touch with you shortly. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "plan-details-card mt-6" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (!$setup.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.detail.name) = $event)),
                  density: "compact",
                  variant: "solo",
                  label: "Connection Name",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.detail.phone) = $event)),
                  density: "compact",
                  variant: "solo",
                  "hide-details": "",
                  class: _normalizeClass({ 'border-red': $setup.submitted && $setup.detail.phone.trim() == '' })
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(" Phone Number "),
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.detail.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.detail.email) = $event)),
                  density: "compact",
                  variant: "solo",
                  "hide-details": "",
                  class: _normalizeClass({ 'border-red': $setup.submitted && $setup.detail.email.trim() == '' })
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(" Email "),
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_autocomplete, {
                  modelValue: $setup.detail.supportType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.detail.supportType) = $event)),
                  density: "compact",
                  variant: "solo",
                  label: "Support Type",
                  items: ['Broadband', 'Leased Line', 'Internet Phone', 'Internet TV'],
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_v_textarea, {
                  modelValue: $setup.detail.message,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.detail.message) = $event)),
                  rows: "3",
                  density: "compact",
                  variant: "solo",
                  label: "Message",
                  "hide-details": ""
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_btn, {
                  class: "btn-primary w-full",
                  style: {"width":"100%"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.sendMail()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Submit")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_v_btn, {
              icon: "mdi-thumb-up",
              color: "success",
              style: {"height":"70px","width":"70px"}
            }),
            _hoisted_13,
            _hoisted_14,
            _createVNode(_component_router_link, {
              to: "/",
              class: "v-btn bg-red py-2 px-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Close")
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}